define 'controller/OnLoadPlPPageController', ['jquery', 'lib/kryptonite'], ($) ->
  class OnLoadPlPPageController

    constructor: (@$el) ->
      @$self = @$el
      @_init()

    _init: ->
      console.log("Running kryptonite " + @$self.data("category-key"));
      searchParam = "?ajax=true";
      locationSearch = window.location.search
      if locationSearch && locationSearch.includes("?")
        searchParam = locationSearch + "&ajax=true"

      $.kryptonite
        url: ''+window.location.pathname + searchParam
        method: 'GET'
        xhrFields:
          showLoadingIndicator: false